// extracted by mini-css-extract-plugin
export default {"bannerVideoContainer":"styles-module__[local]___pMA7j","previewImage":"styles-module__[local]___wtxxU"};